module.exports = () => ({
    restrict: 'AC',
    link(scope, elem) {
        return elem.on('click', ev => ev.stopPropagation());
    }
});
